
import React from 'react';
import { Link } from 'react-router-dom';
import { Settings, LogOut, User as UserIcon } from 'lucide-react';
import { navigationItems, aiFeatures, publicNavigationItems } from './navigationData';
import { useLanguage } from '@/contexts/LanguageContext';

interface MobileNavigationProps {
  user: any;
  isActive: (path: string) => boolean;
  signOut: () => void;
  closeMenu: () => void;
}

const MobileNavigation = ({ user, isActive, signOut, closeMenu }: MobileNavigationProps) => {
  const { t } = useLanguage();
  
  const handleSignOut = () => {
    signOut();
    closeMenu();
  };

  const filteredPublicNavigation = user 
    ? publicNavigationItems.filter(item => item.path !== '/product/ai-predictive')
    : publicNavigationItems;

  return (
    <div className="md:hidden py-4 border-t">
      <div className="space-y-1">
        {user ? (
          <>
            {navigationItems.map(({ path, labelKey, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`flex items-center space-x-3 px-3 py-2 rounded-md text-base font-medium transition-colors ${
                  isActive(path)
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
                onClick={closeMenu}
              >
                <Icon className="h-5 w-5" />
                <span>{labelKey ? t(labelKey) : ''}</span>
              </Link>
            ))}
            
            <div className="border-t pt-2 mt-2">
              <div className="px-3 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                {t('mobile.aiAdvanced')}
              </div>
              {aiFeatures.map(({ path, labelKey, icon: Icon }) => (
                <Link
                  key={path}
                  to={path}
                  className={`flex items-center space-x-3 px-3 py-2 rounded-md text-base font-medium transition-colors ${
                    isActive(path)
                      ? 'bg-purple-100 text-purple-700'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  }`}
                  onClick={closeMenu}
                >
                  <Icon className="h-5 w-5" />
                  <span>{labelKey ? t(labelKey) : ''}</span>
                </Link>
              ))}
            </div>

            <div className="border-t pt-2 mt-2">
              <div className="px-3 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                {t('mobile.user')}: {user.email}
              </div>
              <Link
                to="/settings"
                className="flex items-center space-x-3 px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                onClick={closeMenu}
              >
                <Settings className="h-5 w-5" />
                <span>{t('nav.settings')}</span>
              </Link>
              <button
                onClick={handleSignOut}
                className="flex items-center space-x-3 px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 w-full text-left"
              >
                <LogOut className="h-5 w-5" />
                <span>{t('auth.signOut')}</span>
              </button>
            </div>
          </>
        ) : (
          <>
            {filteredPublicNavigation.map(({ path, labelKey, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`flex items-center space-x-3 px-3 py-2 rounded-md text-base font-medium transition-colors ${
                  isActive(path)
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
                onClick={closeMenu}
              >
                <Icon className="h-5 w-5" />
                <span>{labelKey ? t(labelKey) : ''}</span>
              </Link>
            ))}
            
            <div className="border-t pt-2 mt-2">
              <Link
                to="/auth"
                className="flex items-center space-x-3 px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                onClick={closeMenu}
              >
                <UserIcon className="h-5 w-5" />
                <span>{t('auth.signIn')}</span>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileNavigation;
